import { fontRamp } from "@faire/web--source/slate/Typography";

export const buildTypographyDesignTokensFromFontRamp = () => {
  return Object.entries(fontRamp.fonts).map(([key, value]) => {
    const valueString = Object.entries(value)
      .map(([styleKey, styleValue]) => {
        if (styleKey === "font-family") {
          return `${styleValue}`;
        }
        return `${styleKey}: ${styleValue}`;
      })
      .join("; ");

    return {
      name: key,
      value: `${valueString}`,
    };
  });
};
